import { createSignal } from "solid-js";

import { registerSW } from "virtual:pwa-register";

const [pendingUpdate, setPendingUpdate] = createSignal<() => void>();

export { pendingUpdate };

const isElectron = navigator.userAgent.includes("Electron");

// Service worker registration is unsupported/unnecessary inside the Electron
// desktop app (it's already a native app - no PWA/offline install needed),
// and Electron's service worker handling has known edge cases that can
// throw on registration. Skip entirely there.
const updateSW = isElectron
  ? () => Promise.resolve()
  : registerSW({
  onNeedRefresh() {
    setPendingUpdate(() => void updateSW(true));
  },
  onOfflineReady() {
    console.info("Ready to work offline =)");
    // toast to users
  },
  onRegistered(r) {
    // Check for updates every hour
    setInterval(() => r!.update(), 36e5);
  },
});
